import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import classes from './EditQuestions.module.css'
import { useUpdateDropdownOptions } from "../../../queries/useUpdateDropdownOptions";
import { enqueueSnackbar } from "notistack";
import AppInsight from "../../Azure/AppInsights";
import { getMSID, getToken } from "../../../authfile";
import WithConditional from "../../hoc/WithConditional";
import Loader from "../../UI/Loader";
import { isEmptyString } from "../../../utils/functions";

export const EditQuestions = ({ open, question, report, handleCloseEditQuestionPopup }) => {
    const msid = getMSID();
    const tokenConfig = {
        headers: {
            "Authorization": `Bearer ${getToken()}`,
        },
      };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '80%',
        bgcolor: 'background.paper',
        border: '0.2rem solid #002277',
        boxShadow: 24,
        px: 3,
        overflow: 'auto',
    };

    const [defaultValues, setDefaultValues] = useState({});
    const initialState = {};
    if (question?.values != null && question?.values != undefined) {
        question.values.map((each) => initialState[each['Id']] = each['Drop_Down_Text']);
    }

    useEffect(() => {
        setDefaultValues(initialState);
    }, [])

    const {
        mutateAsync: updateDropdownOptions, isLoading: isLoadingUpdatingOptions
    } = useUpdateDropdownOptions({report});

    const handleChange = (id, value) => {
        setDefaultValues((prev) => ({
            ...prev,
            [id]: value
        }))
    }

    const handleSubmit = () => {
        let DropDownText = "";
        let dropDownid = "";
        let SurveyQuestionId = "";
        for (const x in defaultValues) {
            //checking whether all values are not empty
            if(isEmptyString(defaultValues[x].trim())){
                enqueueSnackbar("Option values Can't be blank",{
                    variant: 'warning'
                });
                return;
            }
            if (defaultValues[x] !== initialState[x]) {
                DropDownText += defaultValues[x] + "|";
                dropDownid += x + "|"
                SurveyQuestionId += question['id'] + "|"
            }
        }
        const body = {
            "SurveyName": report,
            "DropDownText": DropDownText.slice(0, -1),
            "SurveyQuestionId": SurveyQuestionId.slice(0, -1),
            "id": dropDownid.slice(0, -1)
            
        }

        const result = updateDropdownOptions({body: body, config: tokenConfig});
        result.then((res) => {
            if (res.data.error) {
                throw new Error(res.data.message)
            }
            enqueueSnackbar("Options saved successfully", {
                variant: 'success'
            })
            handleCloseEditQuestionPopup();
        }).catch((err) => {
            AppInsight.trackEvent({ name: `RQA => Updating Dropdown options Error, msid=> ${msid}`, properties: { errorMessage: "Something went wrong in Updating Dropdown options" } });
            enqueueSnackbar(`Something went wrong ${err.message}`, {
                variant: 'error'
            });
        })
    }

    //console.log("question is", question);

    return (
        <div className={classes.editQuestion}>
            <WithConditional when={isLoadingUpdatingOptions}>
                <Loader />
            </WithConditional>
            <Typography variant="p" color="primary" sx={{ my: 2, borderBottom: '1px solid #002277', width: 'fit-content' }}>{report}</Typography>
            <div className={classes.question}>
                <Typography variant="p">{question['question_text']}</Typography>
            </div>
            <div className={classes.values}>
                {
                    question['values']?.map((eachValue, index) => (
                        <TextField sx={{ width: '100%', my: 1 }} value={defaultValues[eachValue['Id']]} onChange={(e) => handleChange(eachValue['Id'], e.target.value)} />
                    ))
                }
                <div className={classes.submitButton}>
                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                </div>
            </div>
        </div>
    )
}